import { $t } from 'hooks/i18n';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { CanView } from 'components/Can';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import AccountmasterViewPage from 'pages/accountmaster/View';
import BranchmasterViewPage from 'pages/branchmaster/View';
import EmpmasterViewPage from 'pages/empmaster/View';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
const BranchtransactionListPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const utils = useUtils();
	const filterSchema = {
		search: {
			tagTitle: $t('search'),
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiUrl, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, pagination } = pageController;
	const { filters, setFilterValue } = filterController;
	const { totalPages, currentPage, limit, setPrevPage, setNextPage } =  pagination;
	function ActionButton(data){
		const items = [
		{
			label: $t('view'),
			command: (event) => { app.navigate(`/branchtransaction/view/${data.tranid}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('branchtransaction/view')
		},
		{
			label: $t('edit'),
			command: (event) => { app.navigate(`/branchtransaction/edit/${data.tranid}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('branchtransaction/edit')
		},
		{
			label: $t('delete'),
			command: (event) => { deleteItem(data.tranid) },
			icon: "pi pi-trash",
			visible: () => auth.canView('branchtransaction/delete')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	function TranidTemplate(data){
		if(data){
			return (
				<Link to={`/branchtransaction/view/${data.tranid}`}> { data.tranid }</Link>
			);
		}
	}
	function BranchcodeTemplate(data){
		if(data){
			return (
				<>{data.branchcode && <Button className="p-button-text" icon="pi pi-eye" label={$t('branchmaster')} onClick={() => app.openPageDialog(<BranchmasterViewPage isSubPage apiPath={`/branchmaster/view/${data.branchcode}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function AcCodeTemplate(data){
		if(data){
			return (
				<>{data.ac_code && <Button className="p-button-text" icon="pi pi-eye" label={$t('accountmaster')} onClick={() => app.openPageDialog(<AccountmasterViewPage isSubPage apiPath={`/accountmaster/view/${data.ac_code}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function EmpcodeTemplate(data){
		if(data){
			return (
				<>{data.empcode && <Button className="p-button-text" icon="pi pi-eye" label={$t('empmaster')} onClick={() => app.openPageDialog(<EmpmasterViewPage isSubPage apiPath={`/empmaster/view/${data.empcode}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div  className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">{$t('loading')}</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					{$t('noRecordFound')}
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title={$t('deleteSelected')}/>
				</div>
			)
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-branchtransaction`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel={$t('')} tooltip={$t('export')} buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
	return (
		<div className="flex-grow-1">
			<div className="flex  justify-content-center">
				<div  className="m-2">
					<Button disabled={pagination.currentPage <= 1} label="Previous" onClick={()=>pagination.setPrevPage()} icon="pi pi-arrow-left" />
				</div>
				<div className="m-2">
					<Button disabled={pagination.currentPage >= totalPages} label="Next" onClick={()=>pagination.setNextPage()} icon="pi pi-arrow-right" icon-pos="right" />
				</div>
			</div>
		</div>
	)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="branchtransaction/delete">
		<MultiDelete />
	</CanView>
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="BranchtransactionListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title={$t('branchtransaction')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-fixed " >
                    <CanView pagePath="">
                        <Link to={`/branchtransaction/add`}>
                            <Button label={$t('addNewBranchtransaction')} icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                            </Link>
                        </CanView>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder={$t('search')} className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="page-records">
                                <DataTable 
                                    lazy={true} 
                                    loading={loading} 
                                    selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                    value={records} 
                                    dataKey="tranid" 
                                    sortField={sortBy} 
                                    sortOrder={sortOrder} 
                                    onSort={onSort}
                                    className=" p-datatable-sm" 
                                    stripedRows={true}
                                    showGridlines={false} 
                                    rowHover={true} 
                                    responsiveLayout="stack" 
                                    emptyMessage={<EmptyRecordMessage />} 
                                    >
                                    {/*PageComponentStart*/}
                                    <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                    <Column  field="tranid" header={$t('tranid')} body={TranidTemplate} sortable={true} ></Column>
                                    <Column  field="branchcode" header={$t('branchcode')} body={BranchcodeTemplate} sortable={true} ></Column>
                                    <Column  field="transferdate" header={$t('transferdate')}  sortable={true} ></Column>
                                    <Column  field="debit" header={$t('debit')}  sortable={true} ></Column>
                                    <Column  field="credit" header={$t('credit')}  sortable={true} ></Column>
                                    <Column  field="ac_code" header={$t('acCode')} body={AcCodeTemplate} sortable={true} ></Column>
                                    <Column  field="narration" header={$t('narration')}  sortable={true} ></Column>
                                    <Column  field="empcode" header={$t('empcode')} body={EmpcodeTemplate} sortable={true} ></Column>
                                    <Column  field="dateadded" header={$t('dateadded')}  sortable={true} ></Column>
                                    <Column  field="addedbyfk" header={$t('addedbyfk')}  sortable={true} ></Column>
                                    <Column  field="datemodified" header={$t('datemodified')}  sortable={true} ></Column>
                                    <Column  field="lastuserfk" header={$t('lastuserfk')}  sortable={true} ></Column>
                                    <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                    {/*PageComponentEnd*/}
                                </DataTable>
                            </div>
                            <PageFooter />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
BranchtransactionListPage.defaultProps = {
	primaryKey: 'tranid',
	pageName: 'branchtransaction',
	apiPath: 'branchtransaction/index',
	routeName: 'branchtransactionlist',
	msgBeforeDelete: $t('promptDeleteRecord'),
	msgTitle: $t('deleteRecord'),
	msgAfterDelete: $t('recordDeletedSuccessfully'),
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 50,
}
export default BranchtransactionListPage;
